import { render } from "./recut-new.vue?vue&type=template&id=6171fa2c&scoped=true"
import script from "./recut-new.vue?vue&type=script&lang=js"
export * from "./recut-new.vue?vue&type=script&lang=js"

import "./recut-new.vue?vue&type=style&index=0&id=6171fa2c&scoped=true&lang=css"

import exportComponent from "/Users/hitenradadiya/Front/shiv_mfg_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6171fa2c"]])

export default __exports__